import { frontendURL } from '../../../helper/URLHelper';
import AdministracaoIndex from './pages/AdministracaoIndex.vue';
import DataQualityGovernanceConsole from './pages/DataQualityGovernanceConsole.vue';
import ParceirosOperacionaisIndex from './pages/ParceirosOperacionaisIndex.vue';

export const ADMINISTRACAO_CANONICAL_TABS = Object.freeze([
  'governanca',
  'operacao',
  'parceiros',
  'configuracao',
]);

export const routes = [
  {
    path: frontendURL('accounts/:accountId/administracao'),
    alias: [
      frontendURL('accounts/:accountId/admin'),
      frontendURL('accounts/:accountId/administration'),
    ],
    name: 'administracao_index',
    component: AdministracaoIndex,
    meta: {
      permissions: ['administrator'],
      canonicalTabs: ADMINISTRACAO_CANONICAL_TABS,
      defaultTab: 'governanca',
    },
  },
  {
    path: frontendURL('accounts/:accountId/administracao/qualidade-fraude'),
    alias: [
      frontendURL('accounts/:accountId/administracao/governanca-qualidade'),
      frontendURL('accounts/:accountId/data-quality-governance'),
    ],
    name: 'administracao_qualidade_fraude_index',
    component: DataQualityGovernanceConsole,
    meta: { permissions: ['administrator', 'data_quality_manage'] },
  },
  {
    path: frontendURL('accounts/:accountId/administracao/parceiros'),
    alias: [
      frontendURL('accounts/:accountId/administracao/prestadores'),
      frontendURL('accounts/:accountId/partner-operations'),
    ],
    name: 'administracao_parceiros_index',
    component: ParceirosOperacionaisIndex,
    meta: { permissions: ['administrator', 'agent', 'partners_manage'] },
  },
];
